import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meters-layout',
  templateUrl: './meters-layout.component.html',
  styleUrls: ['./meters-layout.component.scss']
})
export class MetersLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
